// Native
import { Box, Button, HStack, Image, Separator, Text, useDisclosure } from "@chakra-ui/react"
import moment from "moment"

// Custom
import { Parts, UI } from "components"
import { Styles } from "config"
import useAnticipations from "hooks/useAnticipations"
import { useState } from "react"
import useUser from "hooks/useUser"

export default function Anticipations(){

    const user = useUser()
    const anticipations = useAnticipations()
    const [ anticipation, setAnticipation ] = useState(false)
    const request = useDisclosure()
    const list = useDisclosure()
    const career = user.data?.consultant?.career?.current_career
    const style = Styles.pin(career?.id)

    let filtered = anticipations.data?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    let count = 0
    let max = 4

    return(
    <>
    <Parts.Dialog.Anticipations.List {...list} />
    <Parts.Dialog.Anticipations.Request {...request} />
    <Parts.Dialog.Anticipations.View open={!!anticipation} data={anticipation} onClose={() => setAnticipation(false)} />

    <UI.Box loading={anticipations.isLoading}>
        <Text children="Antecipações:" color="GrayText" />

        { filtered?.map(item => {
            if(count >= max) return <></>
            count++

            const style = Styles.pin(item.career.id)

            return(
            <UI.Pressable key={item.id} onClick={() => setAnticipation(item)}>
                <Box py={2} px={2}>
                    <HStack>
                        <Image src={style.image_url} h="30px" />
                        <Box>
                            <Text fontSize="sm">{item.career.title}</Text>
                            <Text fontSize="xs" color="GrayText">{moment(item.created_at).format('LLL')}</Text>
                        </Box>
                    </HStack>
                </Box>
            </UI.Pressable>
            )
        }) }

        <UI.Show visible={anticipations.data?.length > 4}>
            <Button w="100%" mt={4} size="xs" variant="subtle" colorPalette="orange" onClick={list.onOpen}>Ver + {anticipations.data?.length - max} antecipações <UI.Icon name="next" /></Button>
        </UI.Show>

        <Separator my={4} />

        <Button w="100%" variant="subtle" onClick={request.onOpen} colorPalette={style.colorPalette}><UI.Icon name="anticipation" /> Antecipar ciclo agora</Button>
    </UI.Box>
    </>
    )
}